/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class RouteDetailPanel extends React.Component {
    render() {

        let routeName = (this.props.route && this.props.route.name) ? this.props.route.name : '';

        return (
            <div className="editor-panel">
                <form>
                    <fieldset>
                        <legend>Route Name</legend>
                        <ErrorModule
                            app={this.props.app}
                            keys={['ROUTE_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field="name" errors={state.errors}/>
                                );
                            }}/>
                        <UncontrolledTextInput defaultValue={routeName} className="text-input medium" onChange={this.props.changeHandler} data-field="route.name" />

                    </fieldset>
                </form>
            </div>

        );
    }

};

RouteDetailPanel.displayName = "RouteDetailPanel";

RouteDetailPanel.propTypes = {
    route: PropTypes.object,
    routeViewType: PropTypes.number,
    userPerms: PropTypes.object,
    changeHandler: PropTypes.func,
    errors: PropTypes.object,
    setModal: PropTypes.func
};

RouteDetailPanel.defaultProps = {
    route: {},
    routeViewType: 0,
    userPerms: {},
    changeHandler: null,
    errors: null,
    setModal: null
};

export default ComponentWithContext(RouteDetailPanel);
